import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import ResetSettings from 'components/molecules/reset-settings';
import RefreshProjections from 'components/molecules/refresh-projections';
import RefreshGamesStatuses from 'components/molecules/refresh-games-statuses';
import DateHelper from 'helpers/date-helper';
import DownloadPlayersCsvButton from 'components/organisms/players-csv/download-players-csv';
import FileUploaderButton from 'components/organisms/players-csv/upload-players-csv/components/file-uploader-button';

class PlayersInfo extends Component {
    render() {
        const {slate, playersQuantity} = this.props;

        return (
            <div className="main-table-footer">
                <ul className="info-list">
                    <li>
                        <strong className="filtered-players-counter">{playersQuantity}</strong> players
                    </li>
                    {!isEmpty(slate) ? (
                        <li>
                            Last Updated{' '}
                            <strong>{DateHelper.showByFormat(slate.updated_at, 'm/d/yyyy h:MM TT')}</strong>
                        </li>
                    ) : null}
                </ul>
                <div className="main-table-footer-actions">
                    <FileUploaderButton />
                    <DownloadPlayersCsvButton />
                    <RefreshProjections />
                    <RefreshGamesStatuses />
                    <ResetSettings />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    const {slates} = state.playersData;
    return {
        slate: slates.getById(sportConfig.getSlateId()),
    };
}

export default connect(mapStatesToProps)(PlayersInfo);
